import { Navigate } from "react-router-dom";
import { AuthGuard } from "@trillion/auth";
import { RootLayout } from "../layouts/root-layout";
import { AppLayout } from "../layouts/app-layout";
import { LoginPage } from "../pages/login";
import { DashboardPage } from "../pages/dashboard";
import { DiagramPage } from "../pages/diagram";
import { AccessDeniedPage } from "../pages/access-denied";
import { TeamsPage } from "../pages/teams";
import { TeamDetailPage } from "../pages/team-detail";
import { AccessRequestPage } from "../pages/access-request";
import { McpPage } from "../pages/mcp";

export const routes = [
  {
    element: <RootLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/mcp", element: <McpPage /> },
      { path: "/access-denied", element: <AccessDeniedPage /> },
      {
        element: <AppLayout />,
        children: [
          {
            element: <AuthGuard />,
            children: [
              { path: "/dashboard", element: <DashboardPage /> },
              { path: "/d/:diagramId", element: <DiagramPage /> },
              { path: "/teams", element: <TeamsPage /> },
              { path: "/teams/:teamId", element: <TeamDetailPage /> },
              { path: "/d/:diagramId/access-request", element: <AccessRequestPage /> },
            ],
          },
        ],
      },
      { path: "/", element: <Navigate to="/dashboard" replace /> },
    ],
  },
];
